import { createService, z } from '@betty/toolkit/api';
import {
  AccountSchema,
  SourceOfFundsFormSchema,
  MarketingPreferencesSchema,
  UpdateMFARequestSchema,
  CloseAccountRequestSchema,
  UpdateEmployerRequestSchema,
  UpdatePersonalDetailsRequestSchema,
} from './AccountService.schemas';
import { SessionHistoryResponseSchema } from './HistoryService.schemas';

export default createService(
  {
    getAccount: {
      method: 'GET',
      url: '/',
      responseSchema: AccountSchema,
    },
    closeAccount: {
      method: 'POST',
      url: '/status/close',
      requestSchema: CloseAccountRequestSchema,
      responseSchema: z.object({}).optional(),
    },
    updatePersonalDetails: {
      method: 'PUT',
      url: '/personaldetails',
      requestSchema: UpdatePersonalDetailsRequestSchema,
      responseSchema: z.object({}).optional(),
    },
    updateEmployer: {
      method: 'PUT',
      url: '/employer',
      requestSchema: UpdateEmployerRequestSchema,
      responseSchema: z.object({}).optional(),
    },
    getSessionHistory: {
      method: 'GET',
      url: '/sessions',
      responseSchema: SessionHistoryResponseSchema,
    },
    updateScreenName: {
      method: 'PUT',
      url: '/screenName',
      responseSchema: z.object({}).optional(),
    },
    updateSourceOfFunds: {
      method: 'PUT',
      url: ({ id }: { id: number }) => `/sourceoffunds/${id}`,
      responseSchema: SourceOfFundsFormSchema,
    },
    updateMarketingPreferences: {
      method: 'PUT',
      url: '/marketingPreferences',
      requestSchema: MarketingPreferencesSchema,
      responseSchema: z.object({}).optional(),
    },
    updateMFA: {
      method: 'PUT',
      url: '/mfa',
      requestSchema: UpdateMFARequestSchema,
      responseSchema: z.object({}).optional(),
    },
    timeout: {
      method: 'POST',
      url: '/status/takeABreak',
      responseSchema: z.object({}).optional(),
    },
    selfExclusion: {
      method: 'POST',
      url: '/status/selfExclusion',
      responseSchema: z.object({}).optional(),
    },
  },
  ({ userId }) => `/Accounts/${userId}`,
);
